import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import { StageDTO } from "@reflag/shared/stageAPI";

import { stageQueryKeys } from "./stageQueryKeys";

export const useStageData = <TData = StageDTO>(
  stageId?: string,
  queryOptions?: Omit<
    UseQueryOptions<StageDTO, AxiosError<ErrorResponse>, TData>,
    "queryKey" | "queryFn" | "initialData"
  > & { initialData?: () => undefined },
) => {
  const { appId } = useEnvironment();
  return useQuery({
    queryKey: stageQueryKeys.single(appId, stageId),
    queryFn: () =>
      api
        .get<"/apps/:appId/stages/:stageId">(`/apps/${appId}/stages/${stageId}`)
        .then((res) => res.data.stage),
    enabled: !!appId && !!stageId,
    ...queryOptions,
  });
};
